import { render, staticRenderFns } from "./ENabizTransfer.vue?vue&type=template&id=021ccd4c&"
import script from "./ENabizTransfer.vue?vue&type=script&lang=js&"
export * from "./ENabizTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports